export const USER_GROUP_KEY = 'user_group'
